/**
 * VendorTypeService
 * Service for managing vendor types
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor type CRUD operations
 */
export class VendorTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorTypeService.DEFAULT_SERVICE_PATH,
            basePath: VendorTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
VendorTypeService.DEFAULT_SERVICE_PATH = 'vendors';
VendorTypeService.BASE_PATH = 'api/vendor-types';
//# sourceMappingURL=VendorTypeService.js.map